import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ProfilePicture from '../ProfilePicture/ProfilePicture';
import './LoginButton.scss';

const LoginButton = () => {
  const { logout, user, isAuthenticated, loading } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  if (loading) {
    return <div className="login-button login-button--loading">Loading...</div>;
  }

  if (isAuthenticated) {
    return (
      <div className="login-button__user-menu" ref={dropdownRef}>
        <button 
          onClick={() => setShowDropdown(!showDropdown)}
          className="login-button login-button--profile"
        >
          <ProfilePicture size="small" editable={false} />
          <span className="login-button__user-name">
            {user.username || 'Profile'}
          </span>
          <svg className="login-button__dropdown-arrow" viewBox="0 0 12 8">
            <path d="M1 1l5 5 5-5" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        {showDropdown && (
          <div className="login-button__dropdown-menu">
            <Link to="/profile" className="login-button__dropdown-item" onClick={() => setShowDropdown(false)}>
              Profile
            </Link>
            {user && ['admin', 'owner'].includes(user.role) && (
              <Link to="/admin" className="login-button__dropdown-item" onClick={() => setShowDropdown(false)}>
                Admin
              </Link>
            )}
            <Link to="/achievements" className="login-button__dropdown-item" onClick={() => setShowDropdown(false)}>
              Achievements
            </Link>
            <Link to="/stats" className="login-button__dropdown-item" onClick={() => setShowDropdown(false)}>
              Stats
            </Link>
            <Link to="/settings" className="login-button__dropdown-item" onClick={() => setShowDropdown(false)}>
              Settings
            </Link>
            <button onClick={() => { logout(); setShowDropdown(false); }} className="login-button__dropdown-item">
              Logout
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <Link to="/login" className="login-button login-button--login">
      Login
    </Link>
  );
};

export default LoginButton;